/* eslint-disable complexity */
import React from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { styled, truncate } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';

const CollectionBox = styled(Grid)`
  background: ${(props) => props.theme.colors.neutral['000']};
  font-size: 13px;
  color: ${(props) => props.theme.colors.neutral['700']};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  border-top: 1px solid ${(props) => props.theme.colors.neutral['100']};
`;

const Footer = styled(Grid)`
  border-top: 1px dashed ${(props) => props.theme.colors.neutral['100']};
`;

const Body = styled(Grid)`
  min-height: 92px;
  font-weight: ${(props) => props.theme.fontWeights.regular};
`;

const Header = styled.h3`
  line-height: unset;
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
  ${truncate()}
}
`;

const ActionWrap = styled(Grid)`
  & .em-ds-button {
    padding: 0;
    min-width: unset;
  }
`;

const DSCollectionBox = ({ body, title, headerAction, footerAction, headerLevel = 3 }) => {
  const headerCols = [];
  const footerCols = [];
  const rows = [];
  if (headerAction || title) rows.push('40px');
  rows.push('auto');
  if (footerAction) rows.push('40px');

  if (headerAction) headerCols.push('auto');
  if (title) headerCols.push('auto');

  if (footerAction) footerCols.push('auto');

  return (
    <CollectionBox rows={rows}>
      <Grid alignItems="center" cols={headerCols}>
        {title && <Header as={`h${headerLevel}`}>{title}</Header>}
        {headerAction && <ActionWrap justifySelf="end">{headerAction}</ActionWrap>}
      </Grid>
      <Body>{body}</Body>
      {footerAction && (
        <Footer alignItems="center" cols={footerCols}>
          <ActionWrap justifySelf="end">{footerAction}</ActionWrap>
        </Footer>
      )}
    </CollectionBox>
  );
};

const props = {
  /**
   * body inside collection box
   */
  body: PropTypes.element.isRequired.description('body inside collection box'),
  /**
   * Collection box header
   */
  title: PropTypes.string.description('Collection box header'),
  /**
   * Collection box header action, expects a button with size s
   */
  headerAction: PropTypes.element.description('Collection box header action, expects a button with size s'),
  /**
   * Collection box footer action, expects a button with size s
   */
  footerAction: PropTypes.element.description('Collection box footer action, expects a button with size s'),
  /**
   * Semantic header tag used for the header title
   */
  headerLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).description('Semantic header tag used for the header title'),
};

DSCollectionBox.displayName = 'DSCollectionBox';
const DSCollectionBoxWithSchema = describe(DSCollectionBox);
DSCollectionBoxWithSchema.propTypes = props;

export { DSCollectionBox, DSCollectionBoxWithSchema };
